import React from 'react';
import { Button } from './ui/Button';
import { Phone } from 'lucide-react';
export function CTABanner() {
  return <section className="relative w-full py-32 flex items-center justify-center bg-fixed bg-cover bg-center" style={{
    backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/88n9H6duUfUREiU7nFn7S1/landscape-lights.webp")'
  }} data-id="element-18">
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/70" data-id="element-19"></div>

      <div className="relative z-10 container mx-auto px-4 text-center flex flex-col items-center" data-id="element-20">
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white uppercase tracking-wider mb-6" data-id="element-21">
          Ready to Light Up Your Outdoor Space?
        </h2>
        <p className="text-xl md:text-2xl text-gray-200 mb-10 max-w-2xl" data-id="element-22">
          Get a free, no-obligation estimate today.
        </p>

        <Button size="lg" className="w-full sm:w-auto bg-[var(--brand-green)] hover:bg-green-700 text-white font-medium text-xl h-16 px-10 mb-8" data-id="element-23">
          Get Your Free Quote
        </Button>

        <div className="flex items-center justify-center gap-3 text-white text-2xl font-medium" data-id="element-24">
          <Phone className="w-8 h-8 text-[var(--brand-gold)]" data-id="element-25" />
          <a href="tel:480-270-2014" className="hover:text-[var(--brand-gold)] transition-colors" data-id="element-26">
            480-270-2014
          </a>
        </div>
      </div>
    </section>;
}